import { VITE_WS_GATEWAY_URL } from '@env';

import { WsAgent } from '../utils/wsAgent';

// WS
export function emailToSimpleId(email: string): string {
  let id = '';

  for (let i = 0; i < email.length; i++) {
    const charCode = email.charCodeAt(i);
    id += (charCode % 36).toString(16);
  }

  if (id.length < 24) {
    id = id.padEnd(24, '0');
  }

  return id.slice(0, 24);
}

// const wsClientIdEnd = Math.random().toString(16).slice(2);
// export const WS_CLIENT_ID = sessionStorage.getItem('wsClientId') || '0'.repeat(24 - wsClientIdEnd.length) + wsClientIdEnd;
// sessionStorage.setItem('wsClientId', WS_CLIENT_ID);

export const WS_GATEWAY_URL = `${VITE_WS_GATEWAY_URL}/ws/gateway`;

export const WS_AGENT = new WsAgent();

export const formatTime = (time: number): string => {
  const seconds = Math.floor(time / 1000);

  if (seconds < 60) {
    return `${seconds} секунд`;
  }

  const minutes = Math.floor(seconds / 60);

  return `${minutes} минут`;
};

// TOOLTIP
export const TOOLTIP_PARSING_PHRASES_LIMIT = (time: number): string =>
  `Сейчас нельзя запустить парсинг. Повторите попытку через ${formatTime(time)}.`;
export const TOOLTIP_PARSING_PHRASES_MOVING_NEED =
  'Сейчас невозможно запустить парсинг. Сначала перенесите фразы в список.';
export const TOOLTIP_PARSING_PHRASES_DATE_NOT_TODAY =
  'Вы не можете запустить парсинг за прошлую дату. Для запуска парсинга переключитесь на текущую дату';
export const TOOLTIP_CANNOT_PARSE_UNADDED_PHRASES =
  'Вы не можете запустить парсинг в списке "Также найдено", так как эти фразы не добавлены в проект.';
export const TOOLTIP_PARSING_PHRASES_POSITIONS_BUTTON =
  'Определение позиций артикулов по ключевым запросам в поиске WB. Будут проверены все артикулы данного проекта';
export const TOOLTIP_PARSING_ARTICLES_POSITIONS_BUTTON =
  'Определение позиций артикула в блоке "Смотрите также" у других артикулов';
export const TOOLTIP_PARSING_ACTIVE_CHANGE_DISABLE =
  'Невозможно добавить/удалить артикулы пока запущен парсинг';

// COMMON
export const PARSING_INSTRUCTION =
  'Ручной запуск парсинга позиций возможен для проектов, количество фраз которых не превышает 10 000. Пожалуйста, очистите проект от мусорных фраз для возможности ручного запуска парсинга позиций фраз проекта.';

export const NO_RESULT = '–';
export const OUT_OF_STOCK_LABEL = 'Нет в наличии';
export const FORMATTER_LANG = 'ru-RU';

export const CURRENCY_TOKENS = {
  'RUB': '₽',
  'USD': '$',
};
export const IS_LOCALHOST = window.location.hostname === 'localhost';

export const API_WEB_ID = import.meta.env.VITE_AUTH_URL;

export const DAILY_POSITIONS = new Map<number, string>([
  [99991, '1К+'],
  [99992, '2К+'],
  [99993, '3К+'],
  [99995, '5К+'],
  [99996, '6К+'],
  [99997, '6К+'],
  [99998, '6К+'],
  [99999, '6К+'],
  [Infinity, '—'],
]);
export const API_TG = import.meta.env.VITE_REACT_API_TG;

export const SAVE_CARD_MIN_AMOUNT_DEFAULT = 10;
export const SAVE_CARD_MIN_AMOUNT_FOREIGN = 120;
export const TOP_UP_MIN_AMOUNT = 6500;
export const AUTO_TOP_UP_MIN_AMOUNT = 300;
export const MAX_COMPARISON_COUNT = 100;

export const PROJECT_NAME_MAX_LENGTH = 256;
export const PROJECT_NAME_MAX_LENGTH_ERROR_MESSAGE = `Наименование проекта не должно превышать ${PROJECT_NAME_MAX_LENGTH} символов`;
